import { render, staticRenderFns } from "./EditMainScreen.vue?vue&type=template&id=05a7ffcc&scoped=true"
import script from "./EditMainScreen.vue?vue&type=script&lang=js"
export * from "./EditMainScreen.vue?vue&type=script&lang=js"
import style0 from "./EditMainScreen.vue?vue&type=style&index=0&id=05a7ffcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a7ffcc",
  null
  
)

export default component.exports